export default __webpack_public_path__ + "static/media/(32).fe9eccc0.JPG";